module.exports = __webpack_public_path__ + "img/undraw-noted.0087f1d3.svg";